module.exports = __webpack_public_path__ + "img/default-property-img.0b3f8e47.png";